import { render } from "./ShortDescriptionFilter.vue?vue&type=template&id=df40638e"
import script from "./ShortDescriptionFilter.vue?vue&type=script&lang=js"
export * from "./ShortDescriptionFilter.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__